import React, { useState, useRef } from 'react'
import { Card, CardContent, Grid, Chip } from '@material-ui/core'
import {
  components,
  constants,
  useTranslation,
  useServices
} from 'cng-web-lib'
import moment from 'moment-timezone'
import Table from '../../../components/aciacehighway/Table'
import CciHsPastClassificationApiUrls from 'src/apiUrls/CciHsPastClassificationApiUrls'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CciHsCodeClassificationApiUrls from 'src/apiUrls/CciHsCodeClassificationApiUrls.js'
import CngBackdrop from 'src/components/cngcomponents/CngBackDrop';

const {
  locale: {
    key: { UiComponentKeys }
  },
  filter: { LIKE, BETWEEN, EQUAL, IN }
} = constants

const {
  card: { CngSimpleCardHeader },
  table: {
    CngCrudTable,
    DateRangeFilter: CngDateRangeFilter,
    useDefaultNotification
  },
  CngGridItem
} = components

function TablePage(props) {
  const [loading, setLoading] = useState(false);
  const [tableKey, setTableKey] = useState(0);
  const { securedSendRequest } = useServices();
  const {
    location: { pathname },
    showNotification
  } = props
  const notification = useDefaultNotification(showNotification)



  const columns = [
    {
      field: "transactionId",
      sortKey: "transactionId",
      title: "Transaction ID",
    },
    {
      field: "jobType",
      sortKey: "jobType",
      title: "Job Type",
    },
    {
      field: "source",
      sortKey: "source",
      title: "Source",
    },
    {
      field: "status",
      sortKey: "status",
      title: "Status",
      render: (data) => {
        const status = data.status
        return (
          <>
            <Chip
              label={status}
              size='small'
              style={{
                backgroundColor: status?.toLowerCase() === 'error' ? '#DF2901' : '#29A855',
                color: '#ffffff'
              }}
            />
          </>
        )
      }
    },
    {
      field: "createdDate",
      sortKey: "createdDate",
      title: "Timestamp",
      render: (data) =>
        data.createdDate && moment(data.createdDate).tz(moment.tz.guess()).format('D MMM YYYY, HH:mm z')
    },
    {
      field: "userId",
      sortKey: "userId",
      title: "Submitted By",
    },
    {
      field: "remark",
      sortKey: "remark",
      title: "Remark",
    }
  ]

  const filters = [
    {
      label: "Transaction ID",
      type: 'textfield',
      name: 'transactionId',
      operatorType: LIKE
    },
    {
      label: "Job Type",
      type: 'checkbox',
      name: 'jobType',
      operatorType: EQUAL,
      options: [
        { label: 'HS Code Search - Manual', value: 'HS Code Search - Manual', filterValue: { value: 'HS Code Search - Manual' } },
      ]
    },
    {
      label: "Source",
      type: 'checkbox',
      name: 'source',
      operatorType: EQUAL,
      options: [
        { label: 'UI', value: 'UI', filterValue: { value: 'UI' } },
        { label: 'API', value: 'API', filterValue: { value: 'API' } },
      ]
    },
    {
      label: "Status",
      type: 'checkbox',
      name: 'status',
      operatorType: EQUAL,
      options: [
        { label: 'Completed', value: 'Completed', filterValue: { value: 'Completed' } },
        { label: 'Error', value: 'Error', filterValue: { value: 'Error' } },
      ]
    },
    {
      label: "Timestamp",
      type: 'daterange',
      name: 'createdDate',
      operatorType: BETWEEN
    },
    {
      label: "Submitted By",
      type: 'textfield',
      name: 'userId',
      operatorType: LIKE
    },
    {
      label: "Remark",
      type: 'textfield',
      name: 'remark',
      operatorType: LIKE
    }
  ]

  const retry = (rowData) => {

    setLoading(true);
    securedSendRequest.execute('PUT', CciHsCodeClassificationApiUrls.RETRY, rowData,
      (response) => {
        if (response.status === 200) {
          if (response.data) {
            console.log(response)
            var errorFlag = false
            var obj = response.data;
            console.log(obj)
            if (obj.status === "Error") {
              errorFlag = true
              showNotification('error', obj.remark);
            }
            if (!errorFlag) {
              showNotification('success', 'Retry successful.');
            }
          }
          setTableKey(prev => prev + 1);
        }
      },
      (error) => {
        console.error(error)
        showNotification('error', "We've encountered some issue. Please try again later.");
      },
      () => setLoading(false)
    );

  };

  return (
    <>
      <Table
        key={tableKey}
        actions={[]}
        columns={columns}
        compact
        customRowActions={[
          {
            disabled: (rowData) => rowData.status !== 'Error',
            icon: ['fal', 'redo'],
            onClick: (rowData) => {
              retry(rowData);
            },
            tooltip: () => 'Retry'
          }
        ]}
        // customExportData={{ url: CciHsPastClassificationApiUrls.EXPORT_CSV }}
        exportData={{ url: CciHsPastClassificationApiUrls.EXPORT }}
        fetch={{ url: CciHsPastClassificationApiUrls.GET }}
        fetchFilters={[]}
        filters={filters}
        rowActions={(rowData) => rowData.status !== 'Error' ? [{
          icon: <FontAwesomeIcon icon={['fal', 'copy']} />,
          label: 'Retry',
          onClick: {}
        }] : null}
        showNotification={showNotification}
        sortConfig={{
          type: 'column',
          defaultField: 'createdDate',
          defaultDirection: 'DESC'
        }}
        persistSettings
        selectActions={[
        ]}
      />
      <CngGridItem xs={12} sm={9}>
        <CngBackdrop loading={loading} />
      </CngGridItem>
    </>
  )
}

export default TablePage